//@ts-check
import { openInfoDialog } from '@/common/components/kf-dialog';
import { STATUS_FAILURE_NOT_AUTHORIZED } from '@/common/constants';
import store from '@/top/store';
import { generateTabId } from './helpers';

class TabChannel {
  constructor() {
    this._reqId = 0;
    this._channels = new Map();
    this.tabId = generateTabId();
    this.postTasks = new Map();
    try {
      this.mainChannel = new BroadcastChannel('fcti2');
      this.tabChannel = new BroadcastChannel(this.tabId);
    } catch (error) {
      // ignore
    }
    this.inited = false;

    // BroadcastChannelのデータをクリア（Safari）
    try {
      const len = localStorage.length;
      for (let i = 0; i < len; i++) {
        const key = localStorage.key(i);
        if (key.includes('BroadcastChannel')) {
          localStorage.removeItem(key);
        }
      }
    } catch (error) {
      // ignore
    }
  }

  init() {
    if (this.inited) {
      return;
    }
    this.mainChannel.addEventListener('message', async (e) => {
      const data = e.data || {};
      try {
        await this.mainReceived(data);
        this.sendResponse(data, {});
      } catch (e) {
        this.sendResponse(data, {}, e);
      }
    });
    this.inited = true;
  }

  async mainReceived(data) {
    const { type, payload } = data;
    if (type == 'CHECK_LOGIN') {
      return;
    }
    if (type === 'notifyVp') {
      // @ts-ignore
      if (window.chrome && window.chrome.webview && window.chrome.webview.postMessage) {
        // @ts-ignore
        window.chrome.webview.postMessage(payload);
      }
      return;
    }
    store.dispatch(openInfoDialog('ログインしてください'));
    throw { status: STATUS_FAILURE_NOT_AUTHORIZED };
  }

  sendResponse(data, payload = {}, error) {
    const channel = this.getChannel(data.tabId);
    channel.postMessage({
      reqId: data.reqId,
      tabId: data.tabId,
      payload,
      error
    });
  }

  getChannel(id) {
    const channel = this._channels.get(id);
    if (channel != null) {
      return channel;
    }
    const bc = new BroadcastChannel(id);
    this._channels.set(id, bc);
    return bc;
  }
}

const tabChannel = new TabChannel();
export default tabChannel;